/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent, useCallback} from 'react';
import {makeStyles} from '@material-ui/core';
import {Link} from '@ion/core/src/types/entities';

export interface DeviceGroupTitleType {
  groups?: Link[];
  onGroupClick?: Function;
}

const useStyles = makeStyles(() => ({
  groupSections : {
    display       : 'flex',
    alignItems    : 'center',
    letterSpacing : '0.4px'
  },
  groupName : {
    cursor         : 'pointer',
    textDecoration : 'underline'
  }
}));

/**
 * Defines the DeviceGroupTitle component. This component is used to
 * display the group names with tooltip when we click on more groups link
 *
 * ```typescript
 *
 *   import DeviceGroupTitle from './DeviceGroupTitle';
 *
 *   <DeviceGroupTitle  groups={groups} />
 *
 * ```
 */
const DeviceGroupTitle = ({
  groups,
  onGroupClick
}: DeviceGroupTitleType) => {
  const classes     = useStyles();
  const groupLength = groups?.length || 0;

  const onTitleClick = useCallback((group: Link) => (e: MouseEvent<HTMLDivElement>) => {
    onGroupClick(group);
  }, []);

  if (groupLength) {
    return (
      <>
        {
          groups?.slice(1).map(group => {
            return (
              <div className={classes.groupSections}
                onClick={onTitleClick(group)}>
                <span className={classes.groupName}>{group?.title}</span>
              </div>
            );
          })
        }
      </>
    );
  }
  return <div />;
};

export default DeviceGroupTitle;
